import styled from "styled-components";
export const Wrapper = styled.div `
  background-color: ${({ theme }) => theme.colors.grey05};
  width: 100%;
  padding-top: 1.5rem;
  padding-bottom: calc(env(safe-area-inset-bottom) + 1.5rem);
  flex: 1;

  .ciamWrapper {
    min-height: 2.5rem;
  }

  & > div {
    position: initial;
  }

  hr {
    margin: 0.5rem 0;
  }

  button {
    justify-content: flex-start;
    min-width: calc(100% + 1rem);
  }
`;
export const ButtonWrapper = styled.div `
  padding: 1.5rem 0;
  justify-content: center;
  > button {
    justify-content: center;
    min-width: 100%;
  }
`;
export const LinkWrapper = styled.div `
  .TabList {
    margin-bottom: 0;
    > li > div {
      padding-left: 0.5rem;
    }
  }
`;
